import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type {
  Handicap,
  MarketType,
  Odds as OddsType,
  PlaceTerms
} from '@swf/generated/types/api/sports';
import { EachWayPlaceTerms, Icon, Odds } from '@swf/sports/components';
import { OpportunityDescription } from '@swf/sports/components/OpportunityDescription/OpportunityDescription';
import type { EventTypeId } from '@swf/sports/types/eventType';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';
import getRunnerNameWithHandicap from '@swf/sports/utils/getRunnerNameWithHandicap';

import { TXTWCL_EW, TXTWCL_Each_Way, TXTWCL_SP } from './BetDetails.messages.json';
import styles from './BetDetails.scss';

interface Props {
  name: string;
  handicap: Handicap;
  description: string;
  odds?: OddsType;
  eachWaySelected?: boolean;
  placeTerms?: PlaceTerms;
  venue?: string;
  eventTypeId?: EventTypeId;
  marketTime?: string;
  marketType?: MarketType;
  isStartingPriceOpportunity: boolean;
}

const BetDetails: React.FC<Props> = ({
  name,
  description,
  odds,
  handicap,
  eachWaySelected,
  placeTerms,
  venue,
  eventTypeId,
  marketTime,
  marketType,
  isStartingPriceOpportunity
}) => (
  <div className={styles.wrapper}>
    <span className={styles.iconWrapper}>
      <Icon name={getEventTypeIcon(eventTypeId)} size="xl" />
    </span>
    <div className={styles.eventInfoWrapper}>
      <div className={styles.eventName}>
        {getRunnerNameWithHandicap({ runnerName: name, handicap, runnerResultType: undefined })}
        {odds ? (
          <>
            {' '}
            @ <Odds {...odds} />
          </>
        ) : isStartingPriceOpportunity ? (
          <>
            {' '}
            @ <Translation {...TXTWCL_SP} />
          </>
        ) : null}
        {eachWaySelected ? (
          <>
            {' '}
            <Translation {...TXTWCL_EW} />{' '}
          </>
        ) : null}
      </div>
      <OpportunityDescription
        description={description}
        venue={venue}
        eventTypeId={eventTypeId}
        marketTime={marketTime}
        marketType={marketType}
      />
      {eachWaySelected && (
        <span>
          {placeTerms ? (
            <EachWayPlaceTerms placeTerms={placeTerms} />
          ) : (
            <Translation {...TXTWCL_Each_Way} />
          )}
        </span>
      )}
    </div>
  </div>
);

export default BetDetails;
